import styles from './POIPoints.module.scss'
import { POIPointsProps } from './types'
import usePOIPoints from './usePOIPoint'

const POIPoints = ({ mapBounds, imageWidth, imageHeight }: POIPointsProps) => {
  const { points } = usePOIPoints({ mapBounds, imageWidth, imageHeight })

  if (points.length === 0) return null

  return (
    <>
      {points.map((point) => {
        const { id, name, x, y, key } = point
        return (
          <div
            key={id}
            className={`${styles.poiPoint} ${key ? styles.key : null}`}
            style={{ left: `${x}px`, top: `${y}px` }}
            title={name}
          >
            {key}
          </div>
        )
      })}
    </>
  )
}

export default POIPoints
